let customerZip = document.getElementById('shipping-input');  // user input
let btnCalculate = document.getElementById('shipping-btn'); // calculate button
let etaMessage = document.querySelector('#eta-msg');  // display ETA message
let shippingMessage = document.querySelector('#shipping-msg');  // display shipping message

let sku = customerZip.getAttribute('data-product-sku');  // number of stocks
let productInstock = customerZip.getAttribute('data-product-availability');  // number of stocks
let messageCustomOos = customerZip.getAttribute('data-product-message');  // metafield product's out of stock message 
let fulfillmentTimer = customerZip.getAttribute('data-product-time');  // metafield product's shipping cutoff time
  
let latestCutoff = null;  // get latest cutoff time in CST
let currentTimeCST = getCSTTime(new Date()); 
let currentTimeDelta = null;  // delta between latestCutoff and currentTime in CST 

let apiResponse = null;

const cutoffTimes = { // cutoff times for warehouses in CST format
 // 'Turn 14 Distribution API' : '17:00',
  'Tuner Brands'             : '15:00',
  'BC Racing'                : '12:00',
  'Acuity Instruments'       : '12:00',
  'Happy Racer'              : '17:00'
};


document.addEventListener('DOMContentLoaded', function() { 
  
  let shippingForm = document.getElementById('shipping-form'); // shipping form display
  let zipText = document.getElementById("zip-text"); // zipcode display

  if(localStorage.getItem("savedZipCode")) {
    let savedZipCode = localStorage.getItem("savedZipCode"); // remember customer's last entered zipcode 
    zipText.textContent = savedZipCode;  // update zip-text with the saved zipcode
    customerZip.value = savedZipCode; 
    getProductETA();
  }

  customerZip.addEventListener("input", function() {
    customerZip.value = customerZip.value.replace(/\D/g, "");
  });
  
  zipText.addEventListener('click', function() { 
    if (shippingForm.style.display === 'grid') { 
      shippingForm.style.display = 'none';
    } 
    else { 
      shippingForm.style.display = 'grid';
      document.getElementById('shipping-input').focus();
    }
  });

  btnCalculate.addEventListener('click', function() {  
    let zipCode = customerZip.value;
    if (/^\d{5}$/.test(zipCode)) { // validation to ensure the input is a number and exactly 5 digits
        localStorage.setItem("savedZipCode", zipCode);  // save zipcode to localStorage
        zipText.textContent = zipCode;  // update zip text
       getProductETA();
    } 
    else {
        etaMessage.textContent = "Please enter a valid zipcode for a delivery ETA.";
        shippingMessage.textContent = "";
    }
    shippingForm.style.display = 'none';
  });
  
});


function getProductETA() { 
  // instock 
  if(productInstock > 0) {   
      // check if the input zipcode is provided 
      if(customerZip.value !== '') {  
          getProductAPI(sku, customerZip.value).then(data => {
            // console.log("API result: ", data);

           // get the latest cutoff time
          latestCutoff = getCutoffTime(data.closestWarehouse);
          currentTimeDelta = calculateTimeDelta(latestCutoff);

          if (currentTimeDelta > 0) {
            shippingMessage.textContent = "Order within the next " + currentTimeDelta + " hours for same day fulfillment.";
          } 
          else if (currentTimeDelta < 0) {
            shippingMessage.textContent = "Product ships by the next business day.";
          } 
          else {
            shippingMessage.textContent = "Product ships within 24 hours.";
          } 
        });          
    }
    else {  
      // instock but no zipcode provided
      etaMessage.textContent = "Please enter your zipcode for a delivery ETA."; 
    }
   }
  else { 
    // out of stock and custom message metafield is not null
    if(messageCustomOos) { 
      etaMessage.innerHTML = messageCustomOos;  
    }
    else {  
      // out of stock and custom message metafield is null 
      etaMessage.textContent = "Drop ships from manufacturer, please contact us for an ETA."; 
    }
  }
}

function getCutoffTime(warehouse) {
   if(warehouse.includes('T14')) {
       return '17:00';
   }
  return cutoffTimes[warehouse] || 'Warehouse not found.';
}


// Calculate time delta between cutoff time and current time
function calculateTimeDelta(cutoff) {  
  if(!cutoff) {
    console.error('Cutoff time is not available for this warehouse: ', cutoff);
    return null;  
  }

  // parse the cutoff time (e.g., '17:00')
  let [cutoffHours, cutoffMinutes] = cutoff.split(':').map(Number);

  // create a cutoff date in CST (today's date with cutoff hours and minutes)
  let cutoffDate = getCSTTime(new Date()); 
  cutoffDate.setHours(cutoffHours, cutoffMinutes, 0, 0); 

  // calculate the time delta in hours and round down to whole number
  let deltaTime = Math.floor((cutoffDate - currentTimeCST)/ 3600000);
  // console.log("Current time CST: ", currentTimeCST);
  // console.log("Cutoff date: ", cutoffDate); 
  // console.log("Cutoff delta: ", deltaTime);
  return deltaTime;
}


// Create a new Intl.DateTimeFormat to format the time to CST
function getCSTTime(date) {
  const cstOptions = {
    timeZone: 'America/Chicago',
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };
  
  const cstDateStr = new Intl.DateTimeFormat('en-US', cstOptions).format(date);
  let [month, day, year, hour, minute, second] = cstDateStr.match(/\d+/g).map(Number);
  return new Date(year, month - 1, day, hour, minute, second);
}


// Get product ETA from backend
async function getProductAPI(sku, customerZip) {  
  try {
    const response = await fetch(`https://00kdz911a8.execute-api.us-east-2.amazonaws.com/stage1/eta?sku=${sku}&customerzip=${customerZip}`);
    const data = await response.json();
    
    if (data === "Invalid SKU provided") {
      shippingMessage.textContent = "";
      etaMessage.textContent = data + ". ";
    } else {
      etaMessage.textContent = data.ETA + ". ";
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching the data:', error);
    shippingMessage.textContent = "";
    etaMessage.textContent = "Unable to retrieve ETA at this time. Please try again later.";
  }
}